import * as React from 'react';
import classNames from 'classnames';
import { SvgIcon } from 'seduo-ui';
const ImageBadge = ({ icon, text, color, hex, theme, className }) => (<div className={classNames('image-badge', { 'image-badge--dark': theme === 'dark' }, className)}>
        {icon && (<SvgIcon kind={`Badge${icon[0].toUpperCase() + icon.slice(1)}`} className={classNames('image-badge__icon', { [`icon-${color}`]: color })} style={hex && { fill: hex }}/>)}
        <span>{text}</span>
    </div>);
export default ImageBadge;
